import { greekMessages } from '@/plugins/yup-localization';
import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import { isOfDrivingAge, isValidDate } from '@/views/checkouts/schemas/validators';
import * as yup from 'yup';

export const sharedAigFields = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => {
    let schema = {
        ...BaseSchemaBuilder(true, false, legalEntity, false, discountEntity),
        tax_office: yup.string().required(),
        only_driver: yup.boolean().required(),
        name2: yup.string().when('only_driver', {
            is: false,
            then: schema => schema.required(),
        }),
        surname2: yup.string().when('only_driver', {
            is: false,
            then: schema => schema.required(),
        }),
        tax_no2: yup.string().when('only_driver', {
            is: false,
            then: schema => schema
                .matches(/^\d+$/, {
                    message: greekMessages.mixed.isValidAFM,
                })
                .length(9, greekMessages.mixed.isValidAFM)
                .required(),
        }),
        birthDate2: yup.object().when('only_driver', {
            is: false,
            then: schema => schema.shape({
                day: yup.string().required(),
                month: yup.string().required(),
                year: yup.string().required(),
            }).test('isOfDrivingAge', greekMessages.mixed.isOfDrivingAge, isOfDrivingAge)
            .test('isValidDate', greekMessages.mixed.isValidDate, isValidDate),
        }),
        license_years2: yup.number().when('only_driver', {
            is: false,
            then: schema => schema.required(),
        }),
    };

    if (firstDriverAdditionalPremiumLicenseYears) {
        schema = {
            ...schema,
            ...{
                licenseIssueDate: yup.object({
                    day: yup.string().required(),
                    month: yup.string().required(),
                    year: yup.string().required(),
                })
                .test('isValidDate', greekMessages.mixed.isValidDate, isValidDate)
                .required(),
            }
        };
    }

    if (legalEntity) {
        schema = {
            ...schema,
            company_name: yup.string().required(),
        };
    }

    return schema;
};

export const sharedAigSchemaBuilder = (...args) => yup.object(sharedAigFields(...args));
export default sharedAigSchemaBuilder;
